<template>
    <span class="inline-input" :class="{ active: isEditing }">
        <span
            v-if="!isEditing"
            class="input-display"
            @click="startEdit"
        >
            {{ displayValue || placeholder }}
        </span>
        <a-input
            v-else
            ref="input"
            v-model="localValue"
            :type="type"
            class="input-field"
            @blur="finishEdit"
            @keyup.enter="finishEdit"
            @keyup.esc="cancelEdit"
        />
    </span>
</template>

<script>
export default {
    name: 'InlineInput',
    props: {
        value: {
            type: [String, Number],
            default: '',
        },
        placeholder: {
            type: String,
            default: 'value',
        },
        type: {
            type: String,
            default: 'text',
        },
    },
    data() {
        return {
            isEditing: false,
            localValue: this.value,
        };
    },
    computed: {
        displayValue() {
            return this.value || this.localValue;
        },
    },
    methods: {
        startEdit() {
            this.isEditing = true;
            this.localValue = this.value;
            this.$nextTick(() => {
                if (this.$refs.input) {
                    this.$refs.input.focus();
                }
            });
        },
        finishEdit() {
            this.isEditing = false;
            this.$emit('input', this.localValue);
            this.$emit('change', this.localValue);
        },
        cancelEdit() {
            this.isEditing = false;
            this.localValue = this.value;
        },
    },
    watch: {
        value(newVal) {
            this.localValue = newVal;
        },
    },
};
</script>

<style scoped lang="scss">
.inline-input {
    display: inline-flex;
    align-items: center;
    position: relative;

    .input-display {
        font-weight: 600;
        color: #52c41a;
        border-bottom: 2px solid #52c41a;
        padding: 2px 8px;
        cursor: pointer;
        transition: all 0.2s ease;
        display: inline-block;
        min-width: 80px;
        border-radius: 2px;

        &:hover {
            background: #f6ffed;
            border-bottom-color: #389e0d;
            transform: translateY(-1px);
        }

        &:empty::before {
            content: attr(data-placeholder);
            color: #bfbfbf;
            font-style: italic;
        }
    }

    .input-field {
        display: inline-block;
        width: auto;
        min-width: 120px;
        border: none;
        border-bottom: 2px solid #52c41a;
        border-radius: 0;
        box-shadow: none;
        outline: none;
        padding: 2px 8px;
        font-weight: 600;
        color: #52c41a;

        &:focus {
            border-bottom-color: #389e0d;
            box-shadow: 0 2px 4px rgba(82, 196, 26, 0.2);
        }
    }

    &.active {
        .input-display {
            background: #f6ffed;
        }
    }
}
</style>

<style lang="scss">
.inline-input {
    .ant-input {
        border: none !important;
        border-bottom: 2px solid #52c41a !important;
        border-radius: 0 !important;
        box-shadow: none !important;
        padding: 2px 8px !important;
        font-weight: 600 !important;
        color: #52c41a !important;

        &:focus {
            border-bottom-color: #389e0d !important;
            box-shadow: 0 2px 4px rgba(82, 196, 26, 0.2) !important;
        }
    }

    .ant-input-number {
        border: none !important;
        border-bottom: 2px solid #52c41a !important;
        border-radius: 0 !important;
        box-shadow: none !important;
        width: auto !important;
        min-width: 100px !important;

        .ant-input-number-input {
            padding: 2px 8px !important;
            font-weight: 600 !important;
            color: #52c41a !important;
        }

        &:focus,
        &.ant-input-number-focused {
            border-bottom-color: #389e0d !important;
            box-shadow: 0 2px 4px rgba(82, 196, 26, 0.2) !important;
        }
    }
}
</style>


